import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { API_VERSION_BASELINE } from '@/constants/version';
import compareVersions from '@/utils/compareVersions';

export const useVersionStore = defineStore('useVersionStore', () => {
  // The version the live API last reported, through a header or /version.
  const apiVersion = ref<string>();
  const noticeDismissed = ref(false);

  const drift = computed(() => compareVersions(API_VERSION_BASELINE, apiVersion.value));
  const isOutdated = computed(() => drift.value === 'minor' && !noticeDismissed.value);
  const isBlocked = computed(() => drift.value === 'major');

  return { apiVersion, noticeDismissed, drift, isOutdated, isBlocked };
});
